const types = [
  {
    name: "Text",
    category: "basic",
    sqlType: "character varying",
    displayName: "Text",
  },
  {
    name: "Number",
    category: "basic",
    sqlType: "decimal",
    displayName: "Number",
  },
  {
    name: "True/False",
    category: "basic",
    sqlType: "boolean",
    displayName: "True/False",
  },
  {
    name: "Date",
    category: "basic",
    sqlType: "timestamp",
    displayName: "Date",
  },
  {
    name: "Location",
    category: "basic",
    sqlType: "jsonb",
    displayName: "Geographic Location",
  },
  {
    name: "Image",
    category: "basic",
    sqlType: "jsonb",
    displayName: "Image",
  },
  {
    name: "File",
    category: "basic",
    sqlType: "jsonb",
    displayName: "File",
  },
];

export default types;
